import { useState } from "react";

const images = [
  "/images/gallery/shop1.jpg",
  "/images/gallery/shop2.jpg",
  "/images/gallery/shop3.jpg",
  "/images/gallery/shop4.jpg",
  "/images/gallery/shop5.jpg",
  "/images/gallery/shop6.jpg",
];

const Gallery = () => {
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState(0);

  const next = () => {
    setCurrent((prev) => (prev + 1) % images.length);
  };

  const prev = () => {
    setCurrent((prev) =>
      prev === 0 ? images.length - 1 : prev - 1
    );
  };

  return (
    <section className="section gallery" id="gallery">
      <div className="container">
        <h2 className="gallery-title">Our Shop Gallery</h2>
        <p className="section-subtitle">
          Tap to view our shop photos
        </p>

        {/* PREVIEW CARD */}
        <div
          className="gallery-preview"
          onClick={() => {
            setOpen(true);
            setCurrent(0);
          }}
        >
          <img src={images[0]} alt="Shop preview" />
          <span className="gallery-overlay">
            📸 View Gallery
          </span>
        </div>
      </div>

      {/* FULL GALLERY MODAL */}
      {open && (
        <div className="gallery-modal">
          <span className="close" onClick={() => setOpen(false)}>
            &times;
          </span>

          <button className="nav prev" onClick={prev}>
            ‹
          </button>

          <img
            src={images[current]}
            alt="Shop"
            className="gallery-full"
          />

          <button className="nav next" onClick={next}>
            ›
          </button>
        </div>
      )}
    </section>
  );
};

export default Gallery;
